export default "<p>resources works!</p>\n"